"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#FFB656' : _b;
    return (react_1.default.createElement("svg", { width: "25", height: "24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M12.667 2l3.09 6.26 6.91 1.01-5 4.87 1.18 6.88-6.18-3.25-6.18 3.25 1.18-6.88-5-4.87 6.91-1.01L12.667 2z", fill: color, stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Icon;
//# sourceMappingURL=Star.js.map